import { Box, Chip, Stack, Typography } from "@mui/material"
import { Comparison } from "routes/schedule/compare/lib/diff3"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"
import { FrequencyChangeDisplay } from "./frequency-change-display"

export function TaskRow({ task }) {
    const titleOld = task.titleChange?.oldText ?? ""
    const contentOld = task.contentChange?.oldText ?? ""
    const contentNew = task.contentChange?.newText ?? ""
    const noteOld = task.noteChange?.oldText ?? ""
    const noteNew = task.noteChange?.newText ?? ""
    const frequencyChange = task.frequencyChange ?? null

    return (
        <Box
            sx={{
                border: "1px solid",
                borderColor: task.removed
                    ? "error.light"
                    : task.added
                      ? "success.light"
                      : task.hasChange
                        ? "warning.light"
                        : "divider",
                borderRadius: 1,
                p: 1.5,
                bgcolor: task.removed ? "error.lighter" : task.added ? "success.lighter" : undefined,
            }}
        >
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Typography variant="caption" color="text.secondary" sx={{ minWidth: 32, mt: 0.3 }}>
                    {task.position}.
                </Typography>
                <Box flex={1}>
                    <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
                        <Typography variant="body2" fontWeight="bold">
                            <If truthy={task.titleChange}>
                                <Comparison text={task.title ?? ""} original={titleOld} other={titleOld} />
                                <Else>{task.title}</Else>
                            </If>
                        </Typography>
                        <If truthy={task.removed}>
                            <Chip label="removed" size="small" color="error" />
                        </If>
                        <If truthy={task.added}>
                            <Chip label="new" size="small" color="success" />
                        </If>
                    </Stack>

                    <If truthy={frequencyChange}>
                        <Box mb={1}>
                            <FrequencyChangeDisplay change={frequencyChange} />
                        </Box>
                    </If>

                    <If truthy={task.content || task.contentChange}>
                        <Box className="styled-bullets" sx={{ fontSize: "0.875rem", mb: 0.5 }}>
                            <If truthy={task.contentChange}>
                                <Comparison text={contentNew} original={contentOld} other={contentOld} />
                                <Else>
                                    {/* Content is sanitized server-side before storage */}
                                    <Box dangerouslySetInnerHTML={{ __html: task.content ?? "" }} />
                                </Else>
                            </If>
                        </Box>
                    </If>

                    <If truthy={task.note || task.noteChange}>
                        <Box
                            className="styled-bullets"
                            sx={{ fontSize: "0.8rem", color: "text.secondary", fontStyle: "italic" }}
                        >
                            <If truthy={task.noteChange}>
                                <Comparison text={noteNew} original={noteOld} other={noteOld} />
                                <Else>
                                    {/* Content is sanitized server-side before storage */}
                                    <Box dangerouslySetInnerHTML={{ __html: task.note ?? "" }} />
                                </Else>
                            </If>
                        </Box>
                    </If>
                </Box>
            </Stack>
        </Box>
    )
}
